import Currency from 'components/Currency'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

// the appearance hack hides input number arrows, source: https://www.w3schools.com/howto/howto_css_hide_arrow_number.asp
const StyledAmountInput = styled.div`
  div {
    display: flex;
    margin-top: 1rem;

    span {
      color: ${color('grey400')};
      font-weight: 500;
      font-size: 3.5rem;
      line-height: 125%;
      margin-right: 1rem;
    }

    input {
      font-weight: 500;
      font-size: 3.5rem;
      line-height: 125%;
      padding: 0;
      border: 0;
      outline: 0;
      width: 100%;
      box-sizing: border-box;
      flex: 1;
      color: ${color('grey400')};
      overflow: hidden;
      background: transparent;
      -moz-appearance: textfield;

      ::-webkit-outer-spin-button,
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  p {
    color: ${color('error')};
    height: 1rem;
    margin: 0;
    font-weight: 500;
    font-size: 0.875rem;
  }
`

type AmountProps = {
  e2e: string
  error?: React.ReactNode
  onChange: (value: string) => void
  symbol: string
  value: string
}

const AmountInput = ({ e2e, error, onChange, symbol, value }: AmountProps) => (
  <StyledAmountInput>
    <div>
      <span>
        <Currency code={symbol} />
      </span>
      <input
        autoComplete='off'
        data-e2e={`${e2e}Input`}
        min='0'
        name='amount'
        onChange={(ev) => {
          onChange(ev.target.value)
        }}
        placeholder='0'
        type='number'
        value={value}
      />
    </div>
    <p className='error' data-e2e={`${e2e}Error`}>
      {error || ''}
    </p>
  </StyledAmountInput>
)

export default AmountInput
